import { i18next } from '@frontend/i18n';

export const validateCallerLabel = ({ value }: { value: string }) => {
  const validPattern = /^[a-zA-Z0-9-.* ()]+$/;
  if (!validPattern.test(value)) {
    return i18next.t(
      'Invalid characters used. Only letters, numbers, hyphens, periods, asterisks, and parentheses are allowed.',
      { ns: 'phone' }
    );
  }
  if (value.length > 25) {
    return i18next.t('Input must be 26 characters or fewer.', { ns: 'phone' });
  }
  return '';
};
